import { apiDev } from '@/scripts/axios';
import { catchError } from '@/scripts/utils/store-dependent';

const getTiers = () =>
  apiDev
    .get(`bonusTiers`)
    .then(({ data: { response } }) => response)
    .catch(catchError);

const getUserBonuses = () =>
  apiDev
    .get(`account/bonusTiersInfo`)
    .then(({ data: { response } }) => response)
    .catch(catchError);

export { getTiers, getUserBonuses };
